import { render, staticRenderFns } from "./GoogleNews.vue?vue&type=template&id=087ceedb&"
import script from "./GoogleNews.vue?vue&type=script&lang=js&"
export * from "./GoogleNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports